import { Box, Button, Typography } from '@mui/material';

const HeaderFallback = ({
    title,
    buttonLabels,
    children,
}: {
    title: string;
    buttonLabels?: string[];
    children?: any;
}) => {
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    my: 2,
                }}>
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: { xs: '16px', sm: '20px' },
                        fontFamily: 'YekanBalkhHeavy',
                    }}>
                    {title}
                </Typography>

                <Box>
                    {buttonLabels &&
                        buttonLabels?.length > 0 &&
                        buttonLabels?.map((btnLabel, i) => (
                            <Button
                                sx={{ ml: 1 }}
                                key={i}
                                variant="contained"
                                disabled>
                                {btnLabel}
                            </Button>
                        ))}
                </Box>
            </Box>

            {children}
        </>
    );
};

export default HeaderFallback;
